import Swiper, { Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';

function initializeSliderTestmonial(containerId) {
    const sliderTesmonial = new Swiper(containerId, {
        modules: [Navigation],
        spaceBetween: 30,
        slidesPerView: 1,
        loop: true,

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
    });
}

$(function () {
    $('.slider-testmonial').each(function () {
        initializeSliderTestmonial('#' + $(this).attr('id'));
    });
});
